import React from 'react';
import './css/commonpage.css';

function Footer(){
    return (
        <React.Fragment>
            <br/><br/><br/><br/>

            <section class="outerWrapper">
                <h1 class="componentTitle">Footer</h1>
                <p class="componentDescription"></p>
                <br/>
                <div>
                    <footer >
                        <div class="SkatchFooterDark">
                            <h4 class="footerTitle">Skatch</h4>
                            <p class="footerDescription">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Fugiat officiis dicta accusantium nostrum ratione enim quis ipsam eum omnis? Iste quaerat eius architecto ea laudantium sunt pariatur natus ad nam!</p>
                            <a href="#"><i class="fa fa-linkedin"></i></a>
                            <a href="#"><i class="fa fa-facebook-f"></i></a>
                            <a href="#"><i class="fa fa-twitter"></i></a>
                            <a href="#"><i class="fa fa-youtube-play"></i></a>
                            <a href="#"><i class="fa fa-telegram"></i></a>
                            
                        </div>
                        
                        <div class="footerCopyrightSection">
                            Copyright ©2021 All rights reserved
                        </div>
                    </footer>
                    <br/><br/>
            
            <pre class="language-html"><code class="language-html">
            &lt;xmp className="codeSnippets"&gt; {"\n"}
            &lt;footer&gt; {"\n"}
            &lt;div className="SkatchFooterDark"&gt; {"\n"}
                &lt;h4 className="footerTitle"&gt; {"\n"}Skatch&lt;/h4&gt; {"\n"}
                &lt;p className="footerDescription"&gt; {"\n"}
                    Lorem ipsum dolor sit amet
                &lt;/p&gt; {"\n"}
                &lt;a href="#"&gt; {"\n"}&lt;i className="fa fa-linkedin"&gt; {"\n"}&lt;/i&gt; {"\n"}&lt;/a&gt; {"\n"}
                &lt;a href="#"&gt; {"\n"}&lt;i className="fa fa-facebook-f"&gt; {"\n"}&lt;/i&gt; {"\n"}&lt;/a&gt; {"\n"}
                &lt;a href="#"&gt; {"\n"}&lt;i className="fa fa-twitter"&gt; {"\n"}&lt;/i&gt; {"\n"}&lt;/a&gt; {"\n"}
                &lt;a href="#"&gt; {"\n"}&lt;i className="fa fa-youtube-play"&gt; {"\n"}&lt;/i&gt; {"\n"}&lt;/a&gt; {"\n"}
                &lt;a href="#"&gt; {"\n"}&lt;i className="fa fa-telegram"&gt; {"\n"}&lt;/i&gt; {"\n"}&lt;/a&gt; {"\n"}
                
            &lt;/div&gt; {"\n"}

            &lt;div className="footerCopyrightSection"&gt; {"\n"}
                Copyright ©2021 All rights reserved
            &lt;/div&gt; {"\n"}
            &lt;/footer&gt; {"\n"}
            &lt;/xmp&gt; {"\n"}
            </code></pre>
            
            </div>

        <br/>
        <div>
            <footer>
                <div class="SkatchFooterLight">
                    <h4 class="footerTitle">Skatch</h4>
                    <p class="footerDescription">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Fugiat officiis dicta accusantium nostrum ratione enim quis ipsam eum omnis? Iste quaerat eius architecto ea laudantium sunt pariatur natus ad nam!</p>
                    <a href="#"><i class="fa fa-linkedin"></i></a>
                    <a href="#"><i class="fa fa-facebook-f"></i></a>
                    <a href="#"><i class="fa fa-twitter"></i></a>
                    <a href="#"><i class="fa fa-youtube-play"></i></a>
                    <a href="#"><i class="fa fa-telegram"></i></a>
                    
                </div>
                
                <div class="footerCopyrightSection">
                    Copyright ©2021 All rights reserved
                </div>
            </footer>
            <br/><br/>
            
            <pre class="language-html"><code class="language-html">
            &lt;xmp className="codeSnippets"&gt; {"\n"}
            &lt;footer &gt; {"\n"}
            &lt;div className="SkatchFooterLight"&gt; {"\n"}
                &lt;h4 className="footerTitle"&gt; {"\n"}Skatch&lt;/h4&gt; {"\n"}
                &lt;p className="footerDescription"&gt; {"\n"}
                    Lorem ipsum dolor sit amet
                &lt;/p&gt; {"\n"}
                &lt;a href="#"&gt; {"\n"}&lt;i className="fa fa-linkedin"&gt; {"\n"}&lt;/i&gt; {"\n"}&lt;/a&gt; {"\n"}
                &lt;a href="#"&gt; {"\n"}&lt;i className="fa fa-facebook-f"&gt; {"\n"}&lt;/i&gt; {"\n"}&lt;/a&gt; {"\n"}
                &lt;a href="#"&gt; {"\n"}&lt;i className="fa fa-twitter"&gt; {"\n"}&lt;/i&gt; {"\n"}&lt;/a&gt; {"\n"}
                &lt;a href="#"&gt; {"\n"}&lt;i className="fa fa-youtube-play"&gt; {"\n"}&lt;/i&gt; {"\n"}&lt;/a&gt; {"\n"}
                &lt;a href="#"&gt; {"\n"}&lt;i className="fa fa-telegram"&gt; {"\n"}&lt;/i&gt; {"\n"}&lt;/a&gt; {"\n"}
                
            &lt;/div&gt; {"\n"}

            &lt;div className="footerCopyrightSection"&gt; {"\n"}
                Copyright ©2021 All rights reserved
            &lt;/div&gt; {"\n"}
            &lt;/footer&gt; {"\n"}
            &lt;/xmp&gt; {"\n"}
            </code></pre>

            </div>
        <br/>
        <div>
            <p class="componentSubTitle">Menu based Footer</p><br/>
            <footer class="SkatchMenuBasedFooter">
                <div class="InnerSkatchMenuBasedFooter">
                <div>
                    <h4 class="SkatchMenuBasedFooterTitle">Company</h4>
                    <ul><br/>
                        <li><a href="#">About Services</a></li>
                        <li><a href="#">About Us</a></li>
                        <li><a href="#">Privacy Policy</a></li>
                        <li><a href="#">Terms & Conditions</a></li>
                        <li><a href="#">Contact Us</a></li>
                    </ul>
                </div>
                <div>
                    <h4 class="SkatchMenuBasedFooterTitle">Get Help</h4>
                    <ul><br/>
                        <li><a href="#">FAQ</a></li>
                        <li><a href="#">Shipping</a></li>
                        <li><a href="#">Returns</a></li>
                        <li><a href="#">Career</a></li>
                        <li><a href="#">Courses</a></li>
                    </ul>
                </div>
                <div>
                    <h4 class="SkatchMenuBasedFooterTitle">Online Shop</h4>
                    <ul><br/>
                        <li><a href="#">Watch</a></li>
                        <li><a href="#">Phones</a></li>
                        <li><a href="#">Bands</a></li>
                        <li><a href="#">Earphones</a></li>
                    </ul>
                </div>
                <div>
                    <h4 class="SkatchMenuBasedFooterTitle">Follow Us</h4>
                    <div class="SkatchMenuBasedFooterSocialMediaIcons">
                    <br/>
                    <a href="#" title="LinkedIn"><i class="fa fa-linkedin"></i></a>
                    <a href="#" title="Facebook"><i class="fa fa-facebook-f"></i></a>
                    <a href="#" title="Twitter"><i class="fa fa-twitter"></i></a>
                    <a href="#" class="Youtube"><i class="fa fa-youtube-play"></i></a>
                    <a href="#" title="Telegram"><i class="fa fa-telegram"></i></a>
                </div>
                </div>
                </div>
            </footer>
            <br/>
            
            <pre class="language-html"><code class="language-html">
            &lt;xmp className="codeSnippets"&gt; {"\n"}
            &lt;footer className="SkatchMenuBasedFooter"&gt; {"\n"}
            &lt;div className="InnerSkatchMenuBasedFooter"&gt; {"\n"}
            &lt;div&gt; {"\n"}
                &lt;h4 className="SkatchMenuBasedFooterTitle"&gt; {"\n"}Company&lt;/h4&gt; {"\n"}
                &lt;ul&gt; {"\n"}&lt;br/&gt; {"\n"}
                    &lt;li&gt; {"\n"}&lt;a href="#"&gt; {"\n"}About Services&lt;/a&gt; {"\n"}&lt;/li&gt; {"\n"}
                    &lt;li&gt; {"\n"}&lt;a href="#"&gt; {"\n"}About Us&lt;/a&gt; {"\n"}&lt;/li&gt; {"\n"}
                    &lt;li&gt; {"\n"}&lt;a href="#"&gt; {"\n"}Privacy Policy&lt;/a&gt; {"\n"}&lt;/li&gt; {"\n"}
                    &lt;li&gt; {"\n"}&lt;a href="#"&gt; {"\n"}Terms & Conditions&lt;/a&gt; {"\n"}&lt;/li&gt; {"\n"}
                    &lt;li&gt; {"\n"}&lt;a href="#"&gt; {"\n"}Contact Us&lt;/a&gt; {"\n"}&lt;/li&gt; {"\n"}
                &lt;/ul&gt; {"\n"}
            &lt;/div&gt; {"\n"}
            &lt;div&gt; {"\n"}
                &lt;h4 className="SkatchMenuBasedFooterTitle"&gt; {"\n"}Get Help&lt;/h4&gt; {"\n"}
                &lt;ul&gt; {"\n"}&lt;br/&gt; {"\n"}
                    &lt;li&gt; {"\n"}&lt;a href="#"&gt; {"\n"}FAQ&lt;/a&gt; {"\n"}&lt;/li&gt; {"\n"}
                    &lt;li&gt; {"\n"}&lt;a href="#"&gt; {"\n"}Shipping&lt;/a&gt; {"\n"}&lt;/li&gt; {"\n"}
                    &lt;li&gt; {"\n"}&lt;a href="#"&gt; {"\n"}Returns&lt;/a&gt; {"\n"}&lt;/li&gt; {"\n"}
                    &lt;li&gt; {"\n"}&lt;a href="#"&gt; {"\n"}Career&lt;/a&gt; {"\n"}&lt;/li&gt; {"\n"}
                    &lt;li&gt; {"\n"}&lt;a href="#"&gt; {"\n"}Courses&lt;/a&gt; {"\n"}&lt;/li&gt; {"\n"}
                &lt;/ul&gt; {"\n"}
            &lt;/div&gt; {"\n"}
            &lt;div&gt; {"\n"}
                &lt;h4 className="SkatchMenuBasedFooterTitle"&gt; {"\n"}Online Shop&lt;/h4&gt; {"\n"}
                &lt;ul&gt; {"\n"}&lt;br/&gt; {"\n"}
                    &lt;li&gt; {"\n"}&lt;a href="#"&gt; {"\n"}Watch&lt;/a&gt; {"\n"}&lt;/li&gt; {"\n"}
                    &lt;li&gt; {"\n"}&lt;a href="#"&gt; {"\n"}Phones&lt;/a&gt; {"\n"}&lt;/li&gt; {"\n"}
                    &lt;li&gt; {"\n"}&lt;a href="#"&gt; {"\n"}Bands&lt;/a&gt; {"\n"}&lt;/li&gt; {"\n"}
                    &lt;li&gt; {"\n"}&lt;a href="#"&gt; {"\n"}Earphones&lt;/a&gt; {"\n"}&lt;/li&gt; {"\n"}
                &lt;/ul&gt; {"\n"}
            &lt;/div&gt; {"\n"}
            &lt;div&gt; {"\n"}
                &lt;h4 className="SkatchMenuBasedFooterTitle"&gt; {"\n"}Follow Us&lt;/h4&gt; {"\n"}
                &lt;div className="SkatchMenuBasedFooterSocialMediaIcons"&gt; {"\n"}
                &lt;br/&gt; {"\n"}
                &lt;a href="#" title="LinkedIn"&gt; {"\n"}&lt;i className="fa fa-linkedin"&gt; {"\n"}&lt;/i&gt; {"\n"}&lt;/a&gt; {"\n"}
                &lt;a href="#" title="Facebook"&gt; {"\n"}&lt;i className="fa fa-facebook-f"&gt; {"\n"}&lt;/i&gt; {"\n"}&lt;/a&gt; {"\n"}
                &lt;a href="#" title="Twitter"&gt; {"\n"}&lt;i className="fa fa-twitter"&gt; {"\n"}&lt;/i&gt; {"\n"}&lt;/a&gt; {"\n"}
                &lt;a href="#" className="Youtube"&gt; {"\n"}&lt;i className="fa fa-youtube-play"&gt; {"\n"}&lt;/i&gt; {"\n"}&lt;/a&gt; {"\n"}
                &lt;a href="#" title="Telegram"&gt; {"\n"}&lt;i className="fa fa-telegram"&gt; {"\n"}&lt;/i&gt; {"\n"}&lt;/a&gt; {"\n"}
            &lt;/div&gt; {"\n"}
            &lt;/div&gt; {"\n"}
            &lt;/div&gt; {"\n"}
            &lt;/footer&gt; {"\n"}
            &lt;/xmp&gt; {"\n"}
            </code></pre>
            
            </div>
                        
            </section>
        </React.Fragment>
    );
}

export default Footer;